import React from 'react'
import { Field } from 'formik'
import FormTextArea from 'components/form-components/FormTextArea'
import FormCheckboxes from 'components/form-components/FormCheckboxes'
import FormRadio from 'components/form-components/FormRadio'
import CountrySelect from 'components/form-components/CountrySelect'
import ErrorsList from './ErrorsList'
import styled, { ThemeProvider } from 'styled-components'
import {
  formConfig,
  _brandName,
  _goals,
  _email,
  _companyName,
  _sales,
  _genders,
  _categoryList,
  _countryOfOrigin,
  _description,
  _instagramUrl,
  _websiteUrl,
  _foundedInYear,
  _mainContactName,
  _mainContactPhone,
  _prefixContactPhone,
} from './config'

import {
  FormWrap,
  LongColumn,
  ButtonWrap,
  contactFormTheme,
} from 'styles/contact-form'
import FormStatus from '../FormStatus'
import FormLabel from '../FormLabel'
import DefaultField from './DefaultField'
import PhoneField from './PhoneField'
import CategoryForm from '../CategoryForm'
import PrefixPhoneSelect from '../PrefixPhoneSelect'
import Recaptcha from '../Recaptcha'
import SubmitButton from './SubmitButton'

const Form = styled(FormWrap)`
  width: 100%;
`

const PhoneWrapper = styled.div`
  display: flex;
  gap: 16px;
  & > .contact-phone__prefix {
    flex: 1;
  }
  & > .contact-phone__number {
    flex: 3;
  }
`

const ContactForm = ({ handleSubmit, dirty, status }) => (
  <ThemeProvider theme={contactFormTheme}>
    <Form onSubmit={handleSubmit}>
      <LongColumn>
        <DefaultField name={_brandName} />
      </LongColumn>
      <LongColumn>
        <DefaultField name={_companyName} />
      </LongColumn>
      <LongColumn>
        <DefaultField name={_mainContactName} />
      </LongColumn>
      <LongColumn>
        <DefaultField name={_email} />
      </LongColumn>
      <LongColumn>
        <FormLabel text={formConfig.mainContactPhone.label} />
        <PhoneWrapper>
          <Field
            name={_prefixContactPhone}
            placeholder={formConfig.prefixContactPhone.label}
            component={PrefixPhoneSelect}
          />
          <PhoneField name={_mainContactPhone} />
        </PhoneWrapper>
      </LongColumn>
      <LongColumn>
        <FormLabel text={formConfig.description.label} />
        <Field
          name={_description}
          placeholder="Short description of your brand"
          component={FormTextArea}
        />
      </LongColumn>
      <LongColumn>
        <FormLabel text={formConfig.categoryList.label} />
        <Field
          name={_categoryList}
          placeholder="Select the category of your brand"
          component={CategoryForm}
          options={formConfig.categoryList.options}
        />
      </LongColumn>
      <LongColumn>
        <FormLabel text={formConfig.genders.label} />
        <FormCheckboxes name={_genders} options={formConfig.genders.options} />
      </LongColumn>
      <LongColumn>
        <DefaultField name={_foundedInYear} />
      </LongColumn>
      <LongColumn>
        <FormLabel text={formConfig.countryOfOrigin.label} />
        <Field
          name={_countryOfOrigin}
          placeholder={`Enter ${formConfig.countryOfOrigin.label}`}
          component={CountrySelect}
        />
      </LongColumn>
      <LongColumn>
        <DefaultField name={_instagramUrl} />
      </LongColumn>
      <LongColumn>
        <DefaultField name={_websiteUrl} />
      </LongColumn>
      <LongColumn>
        <FormLabel text={formConfig.sales.label} />
        <FormRadio name={_sales} options={formConfig.sales.options} />
      </LongColumn>
      <LongColumn>
        <FormLabel text={formConfig.goals.label} />
        <FormCheckboxes
          name={_goals}
          options={formConfig.goals.options}
          fullWidth
        />
      </LongColumn>
      <LongColumn>
        <Recaptcha />
      </LongColumn>
      <LongColumn>
        <FormStatus status={status} dirty={dirty} />
      </LongColumn>
      <LongColumn>
        <ErrorsList />
      </LongColumn>
      <ButtonWrap>
        <SubmitButton onClick={handleSubmit} />
      </ButtonWrap>
    </Form>
  </ThemeProvider>
)
export default ContactForm
